import { HomePage } from "../features/home";

export const Home = () => {
    // TODO: ADD SEO TAGS
    return <HomePage />;
};
